














































































































import {computed, defineComponent, onMounted, ref, toRefs} from "@vue/composition-api"
import {env} from "@/environment"
import {detectSpeaker} from "@/rooms/speakDetector"

export default defineComponent({
  name: 'Avatar',
  props: {
    id: {type: String, required: true},
    isMuted: {type: Boolean, default: false},
    mediaStream: {type: MediaStream, required: true}
  },
  setup(props, {root}) {
    const {mediaStream, id} = toRefs(props)

    const store = root.$store
    const socket = store.state.ioInfo.socket
    const isSpeaking = ref(false)
    const audioEnabled = ref(true)
    const videoEnabled = ref(true)

    console.log(`Mount avatar ${id}`)

    function toggleVideo() {
      videoEnabled.value = !videoEnabled.value
      mediaStream.value?.getVideoTracks().forEach(track => track.enabled = videoEnabled.value)
    }

    function toggleAudio() {
      audioEnabled.value = !audioEnabled.value
      mediaStream.value?.getAudioTracks().forEach(track => track.enabled = audioEnabled.value)
    }

    onMounted(() => detectSpeaker(mediaStream.value, isSpeaking))

    if (!env.audio) { // mute when debugging
      setTimeout(() => {
        console.log(`Mute avatar ${id.value}`)
        audioEnabled.value = true
        toggleAudio()
      }, 150)
    }

    return {
      isSpeaking,
      audioEnabled,
      videoEnabled,

      avatarBadges: computed(() => store.state.badges.get(id.value)),

      toggleVideo,
      toggleAudio,
      kick: () => {
        console.log(`Vote to kick peer ${id.value}`)
        socket.emit('vote', {action: 'kick', payload: id.value})
      }
    }
  }
})
